import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  codeCreateRequestAction,
  codeModifyRequestAction,
  deleteCodeRequestAction,
  loadCodeGroupAction,
} from "../../redux/reducers/codeManagement";

const StyleScope = styled.div`
  .MuiTypography-displayBlock {
    font-size: 12px;
  }

  .table {
    max-width: 800px;

    th {
      width: 140px;
    }
  }

  .button-area {
    max-width: 800px;
  }

  .list-scroller {
    height: 200px;
    overflow-y: auto;
  }
`;

const useStyles = makeStyles((theme) => ({
  codeGroup: {
    width: "100%",
    maxWidth: 620,
    fontSize: "12px",
  },
}));

export default function CodeGroupForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { codeList, selectCode, selectGroupCode } = useSelector(
    (state) => state.codeManagement
  );
  const [selectCodeId, setSelectCodeId] = React.useState("");
  const [submitData, setSubmitData] = React.useState("");
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: "",
      nm: "",
      description: "",
      useYn: "",
    },
  });
  const [open, setOpen] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);

  useEffect(() => {
    dispatch(loadCodeGroupAction());
  }, []);

  useEffect(() => {
    console.log("selectCode: ", selectCode);

    if (selectCode) {
      let code = searchCode();
      setValue("code", code.cd);
      setValue("nm", code.nm);
      setValue("description", code.desc);
      setValue("useYn", code.useYn);
    } else {
      setValue("code", "");
      setValue("nm", "");
      setValue("description", "");
      setValue("useYn", "");
    }
  }, [selectCode]);

  const handleCancle = () => {
    let code = searchCode();
    setValue("code", code.cd);
    setValue("nm", code.nm);
    setValue("description", code.desc);
    setValue("useYn", code.useYn);
  };

  const searchCode = () => {
    return _.find(codeList, (item) => {
      return item.cd == selectCode;
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectCodeId = (event, index) => {
    setSelectCodeId(index);
  };

  const handleOnSubmit = (data) => {
    setSubmitData(data);

    setOpen(true);
  };

  const handleConfirm = () => {
    handleClose();

    if (selectCode) {
      dispatch(codeModifyRequestAction(submitData));
    } else {
      submitData.code = `${selectGroupCode}${submitData.code}`;
      dispatch(codeCreateRequestAction(submitData));

      reset();
    }
  };

  const handleSubmitClick = () => {
    clearErrors("code", { type: "validate" });
    clearErrors("code", { type: "successCode" });
  };

  const handleCodechange = ({ target }) => {
    if (target.value && typeof target.value == "string") {
      setValue("code", target.value.toUpperCase());
    }
  };

  const handleDuplicateCheck = () => {
    let notDuplicate = true;
    let code = `${selectGroupCode}${getValues("code")}`;

    _.forEach(codeList, (item) => {
      console.log("item.code: ", item.cd);
      console.log("code: ", code);
      if (item.cd == code) {
        notDuplicate = false;
      }
    });

    return notDuplicate;
  };

  const handleDuplicateCheckClick = () => {
    let chk = handleDuplicateCheck();

    clearErrors("code", { type: "validate" });
    clearErrors("code", { type: "successCode" });

    if (chk == false) {
      setError("code", {
        type: "validate",
      });
    } else {
      setError("code", {
        type: "successCode",
      });
    }
  };

  const handleDelete = () => {
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleConfirmDelete = () => {
    dispatch(deleteCodeRequestAction(selectCode));
    handleCloseDelete();
  };

  return (
    <>
      <div className="mt-5 mb-2">
        <Box mt={2}>
          <h3>코드 정보</h3>
        </Box>
        <span>
          <Box color="error.main">
            ( <em className="text-danger">*</em> 는 필수입력 항목입니다.)
          </Box>
        </span>
      </div>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <table className="table">
          <tbody>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="codeGroup">
                  코드그룹
                </InputLabel>
              </th>
              <td scope="row">
                <Box mt={1}>
                  <InputLabel htmlFor="pgSz">{selectGroupCode}</InputLabel>
                </Box>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="code">
                  코드
                </InputLabel>
              </th>
              <td>
                {selectCode ? (
                  <p>
                    <Box mt={1}>{selectCode}</Box>
                  </p>
                ) : (
                  <Grid container>
                    <Grid item xs={9}>
                      <TextField
                        inputProps={{
                          maxLength: 3,
                        }}
                        placeholder="AAA"
                        fullWidth
                        maxLength="3"
                        {...register("code", {
                          required: true,
                          minLength: 3,
                          validate: handleDuplicateCheck,
                        })}
                        onInput={handleCodechange}
                      />

                      {errors.code?.type === "validate" && (
                        <FormHelperText>
                          이미 사용중인 코드입니다.
                        </FormHelperText>
                      )}

                      {errors.code?.type === "successCode" && (
                        <FormHelperText className="text-success">
                          사용 가능한 코드입니다.
                        </FormHelperText>
                      )}

                      {errors.code?.type === "required" && (
                        <FormHelperText>코드를 입력해 주세요.</FormHelperText>
                      )}

                      {errors.code?.type === "minLength" && (
                        <FormHelperText>3자 이상 입력해 주세요.</FormHelperText>
                      )}

                      {errors.duplicateCheck?.type === "manual" && (
                        <FormHelperText>
                          {errors.duplicateCheck?.message}
                        </FormHelperText>
                      )}

                      {errors.duplicate?.type === "manual" && (
                        <FormHelperText>
                          {errors.duplicate?.message}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={3}>
                      <Box ml={1}>
                        <Button
                          variant="contained"
                          className="ms-2"
                          size="small"
                          color="primary"
                          onClick={handleDuplicateCheckClick}
                        >
                          중복 확인
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="code-name">
                  코드명
                </InputLabel>
              </th>
              <td>
                <TextField
                  placeholder="텍스트를 입력해주세요."
                  fullWidth
                  {...register("nm", {
                    required: true,
                  })}
                />

                {errors.nm?.type === "required" && (
                  <FormHelperText>텍스트를 입력해주세요.</FormHelperText>
                )}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel htmlFor="code-name">설명</InputLabel>
              </th>
              <td>
                <TextField
                  fullWidth
                  placeholder="텍스트를 입력해주세요."
                  {...register("description", { required: false })}
                />
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="code-name">
                  사용여부
                </InputLabel>
              </th>
              <td>
                <Controller
                  rules={{
                    required: true,
                  }}
                  defaultValue=""
                  name="useYn"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <RadioGroup
                      aria-label="disp"
                      name="useYn"
                      row
                      value={value}
                      onChange={onChange}
                    >
                      <FormControlLabel
                        value="Y"
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            icon={<span className="radio-icon" />}
                            checkedIcon={
                              <span className="radio-icon-checked" />
                            }
                          />
                        }
                        label="사용"
                      />
                      <FormControlLabel
                        value="N"
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            icon={<span className="radio-icon" />}
                            checkedIcon={
                              <span className="radio-icon-checked" />
                            }
                          />
                        }
                        label="미사용"
                      />
                    </RadioGroup>
                  )}
                />

                {errors.useYn?.type === "required" && (
                  <FormHelperText>사용여부를 선택해 주세요.</FormHelperText>
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="text-end button-area">
          <Grid container className=" button-area">
            <Grid item xs={6} className="text-start">
              {selectGroupCode && (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleDelete}
                >
                  삭제
                </Button>
              )}
            </Grid>
            <Grid item xs={6} className="text-end">
              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={handleCancle}
                >
                  취소
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  type="submit"
                  onClick={handleSubmitClick}
                >
                  {selectCode ? <span>수정</span> : <span>등록</span>}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </div>
      </form>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {selectCode ? "수정하시겠습니까" : "등록하시겠습니까?"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="contained">
            취소
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            autoFocus
            variant="contained"
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"삭제하시겠습니까?"}</DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleCloseDelete}
            color="secondary"
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmDelete}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
